import React from 'react';
import PdfHorizontalBarChart from './charts/PdfHorizontalBarChart';
import PdfHeaderComponent from './PdfHeaderComponent';
import { paginateHorizontalBarData, calculateChartDomain, generatePageTitle } from './utils/chartPagination';

const FourthPageComponent = ({ activitiesData = null, projectData }) => {
  // Transform activities data for horizontal bar chart
  const activitiesChartData = activitiesData?.bountyWiseSubmissionCount?.map(item => ({
    name: item?.title,
    value: item?.submissionCount,
    key: item?._id
  }))?.sort((a, b) => b?.value - a?.value) || [];

  // Paginate the data with max 27 bars per page
  const paginatedData = paginateHorizontalBarData(activitiesChartData, 27);
  
  // Calculate domain and ticks based on all data for consistency
  const { domain, ticks } = calculateChartDomain(activitiesChartData);

  if (paginatedData.length === 0) {
    return (
      <div className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px' }}>
        <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
        <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
          <h2 className="text-lg font-bold text-gray-900 mb-2">Activities</h2>
          <p className="text-xs text-gray-600 mb-3">Total number of submissions per activity</p>
          <div className="bg-grayBgNormal p-4 rounded-lg border border-gray-200 text-center text-gray-500" style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <div className="text-xs">No activities data available</div>
          </div>
        </div>
      </div>
    );
  }

  // Render each page of data
  return (
    <>
      {paginatedData.map((pageData, pageIndex) => {
        const pageNumber = pageIndex + 1;
        const totalPages = paginatedData.length;
        const pageTitle = generatePageTitle("Activities", pageNumber, totalPages);
        return (
          <div key={`activities-page-${pageIndex}`} className="pdf-section pdf-page-break" style={{ display: 'flex', flexDirection: 'column', padding: '20px', height: '100vh' }}>
            <PdfHeaderComponent projectTitle={projectData?.title} organizationName="Solarpunk Guild" />
            <div style={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
              <h2 className="text-lg font-bold text-gray-900 mb-2">{pageTitle}</h2>
              <p className="text-xs text-gray-600 mb-3">Total number of submissions per activity</p>
              
              <div className="bg-grayBgNormal p-4 rounded-lg " style={{ flex: 1, minHeight: '980px' }}>
                <PdfHorizontalBarChart
                  data={pageData}
                  xAxisLabel="Total no. of submissions"
                  yAxisLabel="Activities"
                  barSize={18}
                  showReferenceLine={true}
                  referenceLineValue={Math.max(...ticks) * 0.5}
                  domain={domain}
                  ticks={ticks}
                  showLegend={false}
                />
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default FourthPageComponent;
